import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'mutationobserver-shim'
import 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/bootstrap-vue'
import './plugins/vee-validate'
import Notifications from 'vue-notification'
import VueMoment from 'vue-moment'
import 'lodash'

Vue.use(Notifications)
Vue.use(VueMoment)

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


